export default __webpack_public_path__ + "static/media/chalk-pointer.b1c60d8e.png";